type CloseIconProps = {
  width?: string;
  height?: string;
  fill?: string;
  onClick?: any;
};

const Filter = ({ width, height, fill, onClick }: CloseIconProps) => {
  return (
    <svg
      onClick={onClick}
      width={width ? width : "5vw"}
      height={height ? height : "5vw"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_6931)">
        <path
          fill={fill ? fill : "black"}
          d="M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.404 6L11 12.894V20H13V12.894L17.596 6H6.404Z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1_6931">
          <rect width="24" height="24" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Filter;
{
  /* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_6931)">
<path d="M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.404 6L11 12.894V20H13V12.894L17.596 6H6.404Z" fill="#09121F"/>
</g>
<defs>
<clipPath id="clip0_1_6931">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg> */
}
